// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M9.9 8.5C9.9 10.82 8.02 12.7 5.7 12.7C3.38 12.7 1.5 10.82 1.5 8.5C1.5 6.18 3.38 4.3 5.7 4.3C8.02 4.3 9.9 6.18 9.9 8.5Z',
  'M1.91 10.31C2.75 12.06 5.75 12.4 7.63 10.75C9.13 9.44 8.42 6.71 6.48 6.35C4.87 6.05 3.69 7.5 4.25 8.74C4.68 9.69 6.14 9.99 6.67 8.89',
  'M1.5 14.5H9.25C12.4 14.5 14.5 12.29 14.5 9.15V5.35C14.5 4.11 13.97 3.5 13.2 3.5C12.43 3.5 11.9 4.11 11.9 5.35V8.75',
  'M12.3 3.85C12.05 2.15 12.35 1.55 13.25 1.55M13.95 3.8C13.65 2.75 14.15 2.55 14.75 2.8',
];
